import TAL_UC from "@udc/tal-passport-jssdk";
import router from "../../router";
import {SCHOOL_Id,USER_INFO} from '@/js/utils/constant.js'
import store from "../../store";
import EventBus from '../EventBus'

const inMobile = navigator.userAgent.match(
  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
);
/**
 * 关键操作拦截用户行为，如没登录则跳转至登录页
 */
export const checkLogin=(options)=>{
  const {query}=options
  if(!localStorage.getItem("token")){
    if(inMobile){
      let path=router.currentRoute.fullPath
      if(query){
        for(let key in query){
          path=path+'&'+key+'='+query[key]
        }
      }
      // path=encodeURIComponent(path)
      router.push({
        path:'/mobileLogin',
        query:{
          redirectUrl:path,
        }
      })
    }else{
      EventBus.$emit('changeLoginModal',true)
    }
    return false

  }
  return true
}
/**
 * 退出登录方法，用于清理各种用户状态
 */
export const logOut=()=>{
  const params = {
    data: {},
    success: function (res) {
      localStorage.removeItem(USER_INFO)
      localStorage.removeItem('token')
      localStorage.removeItem(SCHOOL_Id)
      store.dispatch('User/logOut')
      if(inMobile){
        let path=router.currentRoute.fullPath
        router.push({
          path:'/mobileLogin',
          redirectUrl:path
        })
      }
    },
    fail: function (error) {
      console.log(error);
    },
  };
  TAL_UC.loginOut(params);
}
//发送登录用二维码逻辑
/**
 *
 * @param {地区号} areacode
 * @param {手机号} phoneNo
 * @param {点击发送二维码的按钮} sendMsgBtn
 */
export function sendMsgLoginCode(areacode,phoneNo,sendMsgBtn,slideElId,callback){
    console.log('clickSendMsg')
    let  msgTimer=null
    let time=60
    // if(!slideElId){
    //   console.error('请输入滑块元素id')
    //   return
    // }
    const sendSMSCodeLoginparams = {
            data: {
            verify_type: 1,
            phone_code: String(areacode),
            phone: String(phoneNo),
            },
            success: (res) => {
              callback(res)
              if (res.errcode==11021) {
                  // 需要展示滑块
                  // 滑块验证的逻辑是滑动验证通过后，SDK再次调用之前的方法，与后端交互，通过success回调返回这次操作的结果，故需要将方法名和之前的入参数据作为showSlide的参数。
                const param = {
                      slideCallback: "sendSMSCodeLogin", // 滑动验证通过时执行方法名，（即触发滑块的原方法，例如：登录（loginSms），获取验证码（sendSMSCodeLogin），校验旧手机（checkPhone）等等等等）
                      slideParams: sendSMSCodeLoginparams, // 前端滑动验证通过时执行方法名的参数（例如手机号，验证码,success和fail等等）
                      failCallback: (error) => {
                        callback(error)
                        console.log(error)
                      },
                };
                // let slideEl=document.querySelector(`#${slideElId}`)
                // if(slideEl.style.display=="none"){
                //     slideEl.style.display="block"
                // }
                  // 展示滑块
                TAL_UC.showSlide(param);
                return;
              }
              if (res.errcode ==0) {
                  msgTimer = setInterval(() => {
                    sendMsgBtn.style['pointer-events']='none'
                    sendMsgBtn.innerText = `${time--}s后获取`;
                    if (time <= 0) {
                        clearInterval(msgTimer);
                        sendMsgBtn.innerText='发送验证码'
                        sendMsgBtn.style['pointer-events']='auto'
                        msgTimer=null
                    }
                  }, 1000);
              }
            },
            fail: (error) => {
              console.log('fail',error)
               callback(error)
                // reject(error)
            },
    };
    TAL_UC.sendSMSCodeLogin(sendSMSCodeLoginparams);
}
/**
 *
 * @param {地区号} areacode
 * @param {手机号} phoneNo
 * @param {验证码} MsgCode
 * @param {滑块元素} slideElId
 * @param {回调} callback
 * @returns
 */
export function loginByMsgCode(areacode,phoneNo,MsgCode,slideElId,callback){
    if(!slideElId){
      console.error('请输入滑块元素id')
      // return
    }
      const smsLoginParams = {
          data: {
            phone: phoneNo, // 地区不同手机号码规则不同
            phone_code: areacode, // 手机地区码
            sms_code: MsgCode, // 短信验证码
          },
          success: (res) => {
            callback(res)
            if (res.errcode === 11021) {
              const param = {
                slideCallback: "loginSms", // 滑动验证通过时执行方法名，（即触发滑块的原方法，例如：登录（loginSms），获取验证码（sendSMSCodeLogin），校验旧手机（checkPhone）等等等等）
                slideParams: smsLoginParams, // 前端滑动验证通过时执行方法名的参数（例如手机号，验证码,success和fail等等）
                failCallback: function (error) {
                   callback(res)
                },
              };
              TAL_UC.showSlide(param);
              return;
            } else if (res.errcode === 0) {
              // 登录成功
            }
          },
          fail: function (error) {
             callback(error)
          },
          closeCaptchaCallback: function () {
            // 如果需要处理滑块加载失败后的图形验证码用户手动点击关闭时需要传递回调方法【1.11.02版本支持】
            console.log("关闭图形验证弹窗"); // 接入方需要处理的方法，例如关闭弹窗后刷新页面，或者提交/登录注册按钮取消置灰等
            // body...
          },
        };
      TAL_UC.loginSms(smsLoginParams);

}

export function sendMsgCode(areacode,phoneNo,sendMsgBtn,slideElId,callback){
   let  msgTimer=null
   let time=60
   if(!slideElId){
      console.error('请输入滑块元素id')
      return
    }
      const sendSMSCodeparams = {
          data: {
            use: 4,
            phone: phoneNo, // 地区不同手机号码规则不同
            phone_code: areacode, // 手机地区码
          },
          success: (res) => {
            if (res.errcode === 11021) {
              const param = {
                slideCallback: "sendSMSCode", // 滑动验证通过时执行方法名，（即触发滑块的原方法，例如：登录（loginSms），获取验证码（sendSMSCodeLogin），校验旧手机（checkPhone）等等等等）
                slideParams: sendSMSCodeparams, // 前端滑动验证通过时执行方法名的参数（例如手机号，验证码,success和fail等等）
                failCallback: function (error) {
                  callback(error.errmsg);
                },
              };
              callback(res)
              TAL_UC.showSlide(param);
              return;
            } else if (res.errcode === 0) {
               msgTimer = setInterval(() => {
                  sendMsgBtn.style['pointer-events']='none'
                  sendMsgBtn.innerText = `${time--}s后获取`;
                  if (time <= 0) {
                      clearInterval(msgTimer);
                      sendMsgBtn.innerText='发送验证码'
                      sendMsgBtn.style['pointer-events']='auto'
                      msgTimer=null
                  }
                }, 1000);
              // 登录成功
              callback(res);
            } else {
            callback(res)
            }
          },
          fail: function (error) {
            callback(error);
          },
          closeCaptchaCallback: function () {
            // 如果需要处理滑块加载失败后的图形验证码用户手动点击关闭时需要传递回调方法【1.11.02版本支持】
            console.log("关闭图形验证弹窗"); // 接入方需要处理的方法，例如关闭弹窗后刷新页面，或者提交/登录注册按钮取消置灰等
            // body...
          },
        };
      TAL_UC.sendSMSCode(sendSMSCodeparams);

}



// WEBPACK FOOTER //
// ./src/js/utils/login.js